import {IItemContent} from "../../../typescript-library";
import * as React from "react";
import styles from "./ItemRow.module.scss";
import Image from "../../ProductSeries/Image";

interface IItemThumbProps {
  item: IItemContent;
}

const ItemThumb: React.FC<IItemThumbProps> = ({item}) => {
  const {url, title} = item;

  return (
    <div className={styles.itemThumb} aria-hidden="true">
      <a href={url} title={title} tabIndex={-1}>
        <Image item={item} />
      </a>
    </div>
  );
};

export default ItemThumb;
